import React from 'react';
import { Modal, List } from 'semantic-ui-react';
import NoRows from '@/components/table/NoRows';
import FormObjectsListItems from './FormObjectsListItems';

const FormObjectModalContent = ({
  activeIndex,
  canEdit,
  category,
  code,
  component,
  entity,
  errors,
  field,
  fields,
  insertItem,
  isEditing,
  item,
  showEdit,
  updateProperties,
}) => (
  <Modal.Content scrolling className="aridhia-form-object-modal-content pt-10">
    {!item && (
    <NoRows
      buttonText={field?.placeholder}
      className="h-100p min-h-35"
      entity={entity}
      onClick={canEdit ? () => insertItem() : undefined}
    />
    )}
    {item && (
    <List>
      <FormObjectsListItems
        activeIndex={activeIndex}
        canEdit={canEdit}
        category={category}
        code={code}
        component={component}
        errors={errors}
        fields={fields}
        isEditing={isEditing}
        item={item}
        showEdit={showEdit}
        toolTip={fields.length === 1 ? 'left center' : 'bottom right'}
        updateProperties={updateProperties}
      />
    </List>
    )}
  </Modal.Content>
);

export default FormObjectModalContent;
